"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactCard = ContactCard;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
var _ContactMainInfo = require("../../internal/components/ContactMainInfo");
var _internal = require("../partials/ContactFeatures/internal");
var styles = _interopRequireWildcard(require("./styles.module.css"));
var _internal2 = require("../partials/ContactActions/internal");
var _internal3 = require("../partials/ContactAvatar/internal");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Компонент Контакта для использования на карточках
 *
 * Адаптивный
 * Использует useDeviceType из ui-kit
 */
function ContactCard(_ref) {
  let {
    title,
    name,
    href,
    target,
    onNameClick,
    nameIcons,
    avatar,
    labels,
    features,
    subcontact,
    actions,
    theme = 'default',
    qualityInfo
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  const isPremiumTheme = theme === 'premium';
  const isWhiteBackground = isPremiumTheme || deviceType === 'desktop';
  const avatarContext = React.useMemo(() => ({
    size: 72,
    highlight: isPremiumTheme ? 'white_100' : null
  }), [isPremiumTheme]);
  const featuresContext = React.useMemo(() => ({
    background: isWhiteBackground ? 'gray6_100' : 'gray10_100'
  }), [isWhiteBackground]);
  const actionsContext = React.useMemo(() => ({
    mobileButtonBackground: isPremiumTheme ? 'white_100' : 'gray6_100'
  }), [isPremiumTheme]);
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['card'], deviceType !== 'desktop' && styles['mobile'], styles[`theme_` + theme])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['section']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['avatar']
  }, /*#__PURE__*/React.createElement(_internal3.ContactAvatarContext.Provider, {
    value: avatarContext
  }, avatar)), /*#__PURE__*/React.createElement("div", {
    className: styles['main-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-info']
  }, /*#__PURE__*/React.createElement(_ContactMainInfo.ContactMainInfo, {
    NameHeadingComponent: _uiKit.UIHeading3,
    title: title,
    name: name,
    href: href,
    target: target,
    onNameClick: onNameClick,
    nameIcons: nameIcons,
    vertical: isPremiumTheme,
    qualityInfo: qualityInfo
  })), labels)), features && /*#__PURE__*/React.createElement(_internal.ContactFeaturesContext.Provider, {
    value: featuresContext
  }, features)), subcontact && /*#__PURE__*/React.createElement("div", {
    className: styles['section']
  }, subcontact), actions && /*#__PURE__*/React.createElement("div", {
    className: styles['actions']
  }, /*#__PURE__*/React.createElement(_internal2.ContactActionsContext.Provider, {
    value: actionsContext
  }, actions)));
}